import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import BuildIcon from "@mui/icons-material/Build";
import { Box, Stack, Typography } from "@mui/material";
import { useSelector } from "react-redux";
import {
  getDeepViewFieldKey,
  getDeepViewLineageEntry,
} from "../../deepViewFieldMap";
import { renderDeepViewText } from "../../renderDeepViewText";

// Only the income fields are ever computed by the fetcher
const ARTIFICIAL_COLUMN_FIELDS = new Set(["cpa_income", "revshare_income"]);

interface Props {
  /** API key of the column the user clicked, e.g. "total_income_usd" */
  columnKey?: string;
}

const DateCollected = ({ columnKey }: Props) => {
  const deepViewData = useSelector(
    (state: any) => state?.deepView?.deepViewData,
  );
  const lineageEntry = getDeepViewLineageEntry(deepViewData, columnKey);
  const stage1Text = lineageEntry?.stage1_prefilled;

  // Fields the fetcher computes itself get the amber "artificial" treatment
  const isArtificialColumn =
    Number(lineageEntry?.is_artificial_column) > 0 &&
    ARTIFICIAL_COLUMN_FIELDS.has(getDeepViewFieldKey(columnKey) ?? "");

  const accentColor = isArtificialColumn ? "#E65100" : "#01579B";
  const borderColor = isArtificialColumn ? "#ED6C0280" : "#0288D180";
  const backgroundColor = isArtificialColumn ? "#ED6C020A" : "#0288D10A";
  const HeadingIcon = isArtificialColumn ? BuildIcon : CalendarMonthIcon;
  const heading = isArtificialColumn
    ? "Artificial Columns"
    : "How the dates were collected";

  if (!stage1Text) return null;

  return (
    <>
      <Box
        sx={{
          border: `1px solid ${borderColor}`,
          borderRadius: "8px",
          backgroundColor,
          p: 1,
        }}
      >
        <Stack direction="row" alignItems="center" spacing={1} mb={1}>
          <HeadingIcon
            sx={{
              color: accentColor,
              fontSize: 18,
            }}
          />

          <Typography
            sx={{
              color: accentColor,
              fontSize: "14px",
              fontWeight: 500,
              textTransform: "uppercase",
              letterSpacing: "0.5px",
            }}
          >
            {heading}
          </Typography>
        </Stack>

        <Typography
          sx={{
            color: accentColor,
            fontSize: "14px",
            lineHeight: "20px",
          }}
        >
          {renderDeepViewText(stage1Text)}
        </Typography>
      </Box>
    </>
  );
};

export default DateCollected;
